// src/pill/src/pill.tsx
import { cva } from "class-variance-authority";
import { ScreenReaderOnly } from "@thisisbud/gds-shared-utilities";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var pillVariants = cva(
  "max-w-min whitespace-pre rounded-full px-4 py-1 text-sm",
  {
    variants: {
      status: {
        error: ["bg-state-negative-background", "text-state-negative-text"],
        info: ["bg-state-info-background", "text-state-info-text"],
        neutral: ["bg-surface-subtle", "text-surface-dark"],
        success: ["bg-state-positive-background", "text-state-positive-text"],
        warning: ["bg-state-warning-background", "text-state-warning-text"]
      }
    }
  }
);
var Pill = ({ text, accessibleText, status }) => /* @__PURE__ */ jsx("span", { className: pillVariants({ status }), children: Boolean(accessibleText) ? /* @__PURE__ */ jsxs(Fragment, { children: [
  /* @__PURE__ */ jsx(ScreenReaderOnly, { children: accessibleText }),
  /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: text })
] }) : /* @__PURE__ */ jsx("span", { children: text }) });

export {
  Pill
};
